import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import type { IResponseMediaShort } from 'entities/Attachment'
import { SMSMessageFieldStore } from 'widgets/MessageFormFields/SMSMessageField/store/SMSMessageFieldStore'
import { EnumVariantMessageField } from 'widgets/MessageField'
import { type IFlowSendFromBlockParams, SendFromBlockStore } from 'widgets/Flow/blocks/SendFrom'

export type IFlowSendSMSBlockParams = {
  sms: {
    body: string | null
    mediaUrls?: IResponseMediaShort[]
  }
  sendFrom: IFlowSendFromBlockParams
}

export class SendSMSBlockStore {
  smsMessageFieldStore: SMSMessageFieldStore
  sendFromBlockStore: SendFromBlockStore
  constructor(private _entities: IEntitiesStore, params?: IFlowSendSMSBlockParams) {
    this.smsMessageFieldStore = new SMSMessageFieldStore(
      {
        onFocus: () => {
          this.setSmsError('')
        },
        messageFieldStoreProps: {
          variant: EnumVariantMessageField.Default,
          resetOnUnmount: false,
        },
      },
      this._entities
    )

    this.sendFromBlockStore = new SendFromBlockStore(this._entities, params?.sendFrom, {
      excludeDeprioritizedNumbers: true,
      getDropdownItemsOptions: {
        showOnlyVerifiedToolFree: true,
      },
    })

    if (params) {
      this.smsMessageFieldStore.init(params.sms.body || '', params.sms.mediaUrls)
    }
    makeAutoObservable(this)
  }

  get params(): IFlowSendSMSBlockParams {
    return {
      sms: {
        body: this.smsMessageFieldStore.messageDataParams.message,
        mediaUrls: this.smsMessageFieldStore.messageDataParams.media_url,
      },
      sendFrom: this.sendFromBlockStore.params,
    }
  }

  validate = () => {
    let isValid = true
    const isValidSendFrom = this.sendFromBlockStore.validate()
    if (!isValidSendFrom) {
      isValid = false
    }
    if (this.smsMessageFieldStore.isError) {
      isValid = false
    }
    if (!this.params.sms?.body) {
      this.setSmsError('Add a message to continue')
      isValid = false
    } else {
      this.setSmsError('')
    }

    return isValid
  }

  get isConfigurationError() {
    return !!this.smsError || !!this.sendFromBlockStore.error || this.smsMessageFieldStore.isError
  }

  private _smsError = ''
  get smsError() {
    return this._smsError
  }
  setSmsError = (value: string) => {
    this._smsError = value
  }

  setSendFromError = (value: string) => {
    this.sendFromBlockStore.setError(value)
  }
}
